import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { overlay: String };

  connect() {
    this.showPanel(0);
    this.scrollToCurrentStep();
  }

  show(event) {
    this.showPanel(Number.parseInt(event.params.stepIndex, 10));
  }

  showPanel(index) {
    const panels = this.panels();

    if (Number.isNaN(index) || index < 0 || index >= panels.length) return;

    panels.forEach((panel, panelIndex) => {
      panel.classList.toggle("hidden", panelIndex !== index);
      panel.setAttribute("aria-hidden", (panelIndex !== index).toString());
    });

    document.querySelector(`${this.overlayValue} > .overflow-y-auto`)?.scrollTo({ top: 0 });
  }

  panels() {
    if (!this.hasOverlayValue) return [];

    return Array.from(
      document.querySelectorAll(`${this.overlayValue} [data-timeline-target='panel']`),
    );
  }

  scrollToCurrentStep() {
    const currentStep = this.element.querySelector("[data-timeline-step-state='current']");
    if (!currentStep) return;

    currentStep.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
  }
}
